import { render, staticRenderFns } from "./BackerCenterThumbnail.vue?vue&type=template&id=56e22f88"
import script from "./BackerCenterThumbnail.vue?vue&type=script&lang=js"
export * from "./BackerCenterThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports